import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames/bind";

import { IState } from "../../store";
import { removeMessage } from "../../store/services/messages";

import styles from "./Messages.module.scss";

const cx = classNames.bind(styles);

const Messages = () => {
  const dispatch = useDispatch();
  const messages = useSelector((state: IState) => state.messagesReducer.messages);

  // Auto-remove success messages after 3 seconds
  useEffect(() => {
    messages.forEach((message) => {
      if (message.type === 'success') {
        const timer = setTimeout(() => {
          dispatch(removeMessage(message.id));
        }, 3000);
        
        // Clean up timer if component unmounts or message changes
        return () => clearTimeout(timer);
      }
    });
  }, [messages, dispatch]);

  const handleRemoveMessage = (id: string) => {
    dispatch(removeMessage(id));
  };

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className={cx("messages-container")}>
      {messages.map((message) => (
        <div
          key={message.id}
          className={cx("message", message.type)}
          onClick={() => handleRemoveMessage(message.id)}
        >
          <span>{message.text}</span>
          <button
            type="button"
            className={cx("message-close")}
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveMessage(message.id);
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default Messages; 